import { PhoneNumberUtil } from 'google-libphonenumber'

import { MAX_ORG_PHONE_NO_LENGTH } from '../../constants/InputsLength'

const DEFAULT_PHONE_REGION = 'SE'

let phoneNumberUtil: PhoneNumberUtil | undefined

const getPhoneNumberUtil = (): PhoneNumberUtil => (phoneNumberUtil ??= PhoneNumberUtil.getInstance())

export function validateEmailFormat(email: string): boolean {
    const regex =
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

    return email.slice(0, email.indexOf('@')).length < 64 && !!email.toLowerCase().match(regex)
}

export function validatePhoneNumber(phoneNumber?: string | null): boolean {
    if (!phoneNumber) return true
    if (phoneNumber.length > MAX_ORG_PHONE_NO_LENGTH) return false

    try {
        const util = getPhoneNumberUtil()
        const parsedPhoneNumber = util.parseAndKeepRawInput(phoneNumber, DEFAULT_PHONE_REGION)

        return util.isValidNumber(parsedPhoneNumber)
    } catch {
        return false
    }
}

export function validateHostNameFormat(hostname: string): boolean {
    const topLevelDomain = hostname.substring(0, hostname.indexOf('.'))
    const containsOnlyLetters = (value: string) => value.match(/^[A-Za-z]+$/)

    return (
        topLevelDomain.length !== 0 &&
        !!containsOnlyLetters(topLevelDomain) &&
        `${topLevelDomain}.charge.space` === hostname
    )
}
